import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';

import useAnalytics from './hooks/useAnalytics';

import FullScreenLoader from './Components/Loader/FullScreenLoader';
import ScrollToHash from './Components/ScrollToHash/ScrollToHash';

const TMO = lazy(() => import('./Components/TMO/TMO'));
const PrivacyPolicy = lazy(() => import('./Components/PrivacyPolicy/PrivacyPolicy'));
const TermsOfService = lazy(() => import('./Components/TermsOfService/TermsOfService'));
const BecomePartner = lazy(() => import('./Components/BecomePartner/BecomePartner'));
const BecomeAffiliate = lazy(() => import('./Components/BecomeAffiliate/BecomeAffiliate'));

const AnalyticsTracker = () => {
  useAnalytics();
  return null;
};

const App = () => (
  <BrowserRouter>
    <ScrollToHash />
    <AnalyticsTracker />

    <Suspense fallback={<FullScreenLoader />}>
      <Routes>
        <Route path="/" element={<TMO />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/partner" element={<BecomePartner />} />
        <Route path="/affiliate" element={<BecomeAffiliate />} />
      </Routes>
    </Suspense>
  </BrowserRouter>
);

export default App;